import DynamicFormRenderer from "shared/form/renderer";
import Button from "shared/components/button";
import ButtonType from "shared/enums/ButtonTypes";
import { TicketUpgradeFormPropsType } from "./type";
import useTicketUpgradeFormService from "./service";
import { useRegDetail } from "shared/context/regDetail";
import { useCopies } from "shared/hooks/useCopies";
import { useParticipantDetails } from "../../../../context/participantDetails";
import ButtonGroup from "shared/components/button/components/buttonGroup";

export default function TicketUpgradeForm(props: TicketUpgradeFormPropsType) {
  const copies = useCopies();
  const service = useTicketUpgradeFormService(props);
  const { currencyCode, id, eventSeriesId } = useRegDetail();
  const { participantDetails } = useParticipantDetails();
  return (
    <div>
      <div className="buyTicket_formGroup--form">
        <DynamicFormRenderer
          key={props.regParticipantFormDetails.uiVersion}
          formRef={service.formRef}
          schemaList={props.regParticipantFormDetails.profile || []}
          parseValuesOnSubmitToApiReq={true}
          formSubmitHandler={service.submitHandler}
          customData={{
            organizationId: props.regParticipantFormDetails.registrationOrganizationId,
            currencyCode,
            registrationId: id,
            eventSeriesId: eventSeriesId,
            registrationParticipantId: participantDetails?.registrationParticipantId
          }}
        />
        <ButtonGroup inlineFormButtons>
          <Button
            className="stylizedLargeBtn"
            label={copies.get("ticket.upgrade.form.save.label")}
            type={ButtonType.SUBMIT}
            onClick={() => service.formRef.current?.submitForm()}
          />
        </ButtonGroup>
      </div>
    </div>
  );
}
